import apiService from "./api.service";
import authService from "./auth.service";
import { logout } from "../helpers/logout";

// albaranGET espera dateFrom/dateTo en YYYY-MM-DD y rechaza la peticion si no lo son, pero la
// vista guarda el rango como epoch ms (el getTime() del selector de fechas).
//
// Se formatea con los componentes LOCALES a proposito: getTime() devuelve la medianoche local
// del dia elegido, asi que toISOString() lo pasaria a UTC y restaria un dia en horario de
// verano -elegir el 1 de julio acabaria pidiendo el 30 de junio-.
const toApiDate = (value) => {
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return null
  const mm = String(d.getMonth() + 1).padStart(2, '0')
  const dd = String(d.getDate()).padStart(2, '0')
  return `${d.getFullYear()}-${mm}-${dd}`
}

const getAll = async ({ per_page, page, archive = false, date_from, date_to }) => {
  const userToken = await authService.getAuthToken()
  const params = new URLSearchParams({
    per_page: per_page,
    page: page,
    archive: archive,
  })
  if (date_from && date_to) {
    const dateFrom = toApiDate(date_from)
    const dateTo = toApiDate(date_to)
    if (dateFrom && dateTo) {
      params.set('dateFrom', dateFrom)
      params.set('dateTo', dateTo)
    }
  }
  return fetch(
    apiService.getEndpoint("ALBARANES") + '?' + params.toString(),
    {
      method: "GET",
      headers: {
        Authorization: userToken,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  )
    .then((response) => response.json())
    .then((data) => data)
    .catch((err) => {logout(err)});
};

const getById = async ({ albaranId }) => {
  const userToken = await authService.getAuthToken()
  return fetch(
    apiService.getEndpoint("ALBARANES") + `/${albaranId}`,
    {
      method: "GET",
      headers: {
        Authorization: userToken,
      },
    }
  )
    .then((response) => response.json())
    .catch((err) => {logout(err)});
};

const insertDevoluciones = async ({ devoluciones }) => {
  const userToken = await authService.getAuthToken()
  return fetch(
    apiService.getEndpoint("DEVOLUCIONES"),
    {
      method: "POST",
      headers: {
        Authorization: userToken,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(devoluciones),
    }
  ).then((response) => response.json())
  .catch((err) => {logout(err)});
};

const albaranesService = {
  getAll,
  getById,
  insertDevoluciones,
};

export default albaranesService;
